import { PipeTransform } from '@angular/core';
var CuitPipe = /** @class */ (function () {
    function CuitPipe() {
    }
    CuitPipe.prototype.transform = function (val) {
        return this.seCuitFormat(val);
    };
    CuitPipe.prototype.seCuitFormat = function (value) {
        return value.replace(/(\d{2})(\d{8})(\d{1})/, '$1-$2-$3');
    };
    return CuitPipe;
}());
export { CuitPipe };
